import {useRole} from '../userInfo/hooks/useRole';

/**
 * A route component that renders its children if the user can subscribe.
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.children - The child components to render.
 * @returns {React.ReactNode|null} The rendered children or null if the user cannot subscribe.
 */
const CanSubscribeRoute = ({children}) => {
  const {canSubscribe} = useRole();
  console.log(canSubscribe);
  return canSubscribe ? children : null;
};

export default CanSubscribeRoute;
